export default __webpack_public_path__ + "static/media/Bastion_HTB.ff6575d2.md";